module.exports = __webpack_public_path__ + "static/media/note-3.52f1cd86.svg";